/* eslint-disable import/prefer-default-export */
import makeApiCall from './makeApiCall';

export const getPrdDashboardList = (params) => makeApiCall(`/prd-dashboard/list`, 'POST', params);
